import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, tap } from 'rxjs/operators';

import * as groupsActions from './groups.actions';

import { Router } from '@angular/router';
import { RoutesService } from '../../shared/services/routes.service';
import { GroupsService } from '../../shared/services/groups.service';


@Injectable()
export class GroupsEffects {

    constructor(
        private itemsService: GroupsService,
        private actions$: Actions,
        private router: Router,
        private routesService: RoutesService
    ) { }

    @Effect()
    DoGetInfoGroups$: Observable<Action> = this.actions$.pipe(
        ofType(groupsActions.DO_GET_INFO_GROUPS),
        switchMap((action: groupsActions.DoGetInfoGroups) => {
            return this.itemsService.get(action).pipe(
                map( response => {
                    response.list = this.itemsService.transformListFromApi(response.list);
                    return new groupsActions.DoGetInfoGroupsOK(response);
                }),
                catchError(error => of(new groupsActions.DoGetInfoGroupsKO(error)))
            );
        }));

    @Effect()
    DoGetInfoGroupsFilters$: Observable<Action> = this.actions$.pipe(
        ofType(groupsActions.DO_GET_INFO_FILTERS),
        switchMap((action: groupsActions.DoGetInfoGroupsFilters) => {
            return this.itemsService.getFilters().pipe(
                map( response => new groupsActions.DoGetInfoGroupsFiltersOK(response)),
                catchError(error => of(new groupsActions.DoGetInfoGroupsFiltersKO(error)))
            );
        }));


    @Effect()
    DoSetSelectedFilters$: Observable<Action> = this.actions$.pipe(
        ofType(groupsActions.DO_SET_SELECTED_FILTERS),
        switchMap((action: groupsActions.DoSetSelectedFilters) => {
            return this.itemsService.get(action).pipe(
                map( response => {
                    response.list = this.itemsService.transformListFromApi(response.list);
                    return new groupsActions.DoGetInfoGroupsOK(response);
                }),
                catchError(error => of(new groupsActions.DoGetInfoGroupsFiltersKO(error)))
            );
        }));
}
